import { api } from 'api'
import { path } from 'ramda'
import { TimelineShift } from 'api/shift'

export async function getReviewTryoutsShifts() {
  const data = await api.post(
    '/company/graphql_dispatch/shifts_to_review_tryouts_5f29674b',
    {}
  )

  return path(
    ['data', 'data', 'company', 'tryoutReviewShifts'],
    data
  ) as TimelineShift[]
}
